import Cookies from 'js-cookie';

import { fetchGroups } from '../features/groups/groupsSlice';
import { fetchLocations } from '../features/locations/locationsSlice';
import { fetchMachines } from '../features/machines/machinesSlice';
import { fetchMaintenanceTypes } from '../features/maintenanceTypes/maintenanceTypesSlice';
import { fetchSupplies } from '../features/supplies/suppliesSlice';
import { fetchUsers } from '../features/users/usersSlice';

function fetchData() {
  // Only fetch critical authentication/user data globally
  // All other data will be loaded on-demand by individual pages
  return;
}

export const fetchUsersData = (dispatch) => {
  const token = Cookies.get('token');
  if (!token) return;
  dispatch(fetchUsers());
};

export const fetchMachinesData = (dispatch) => {
  const token = Cookies.get('token');
  if (!token) return;
  dispatch(fetchMachines());
};

export const fetchMachinesWithDependencies = (dispatch) => {
  const token = Cookies.get('token');
  if (!token) return;
  dispatch(fetchMachines());
  dispatch(fetchGroups());
  dispatch(fetchLocations());
  dispatch(fetchMaintenanceTypes());
  dispatch(fetchUsers());
};

export const fetchSuppliesData = (dispatch) => {
  const token = Cookies.get('token');
  if (!token) return;
  dispatch(fetchSupplies());
};

export default fetchData;
